const regex = /^(?:urn:)?(?:air:)?(?:(?<ecosystem>[a-zA-Z0-9_\-\/]+):)?(?:(?<type>[a-zA-Z0-9_\-\/]+):)?(?<source>[a-zA-Z0-9_\-\/]+):(?<id>[a-zA-Z0-9_\-\/]+)(?:@(?<version>[a-zA-Z0-9_\-]+))?(?:\.(?<format>[a-zA-Z0-9_\-]+))?$/i;
/** https://github.com/civitai/civitai/wiki/AIR-%E2%80%90-Uniform-Resource-Names-for-AI */
export class Air {
    static parse(identifier) {
        const match = regex.exec(identifier);
        if (!match) {
            throw new Error(`Invalid identifier: ${identifier}`);
        }
        return match.groups;
    }
    static parseSafe(identifier) {
        const match = identifier.match(regex);
        return match === null || match === void 0 ? void 0 : match.groups;
    }
    static isAir(identifier) {
        return regex.test(identifier);
    }
    static stringify({ ecosystem, type, source, id, version, format }) {
        return `urn:air:${ecosystem}:${type}:${source}:${id}${version ? `@${version}` : ''}${format ? `:${format}` : ''}`;
    }
}
